import axios from 'axios';
import { getEvaSearchEnvironmentUrl } from '../../utils';
import { getUserTimezoneInfo } from '../../utils/timezoneUtils';
import { refreshToken } from '../../auth/authUtils';

// Common API handler
async function bannerApiRequest(endpoint, payload = {}, isRetry = false) {
    try {
        const token = sessionStorage.getItem('access_token');
        if (!token) throw new Error('Bearer token not found');
        const EVA_BASE_URL = getEvaSearchEnvironmentUrl();
        
        // Get user timezone information
        const { timezone, offset } = getUserTimezoneInfo();
        
        // Common headers
        const headers = {
            'accept': '*/*',
            'X-USER-AGENT': 'eva',
            'X-Tenant': 'uhg',
            'X-portalsource': 'azuread',
            'user-timezone': timezone,
            'user-offset': offset,
            Authorization: `Bearer ${token}`,
        };

        // Add Content-Type only for savebanner endpoint
        if (endpoint === 'v1/savebanner') {
            headers['Content-Type'] = 'application/json';
        }

        const response = await axios.post( `${EVA_BASE_URL}${endpoint}`, payload, { headers } );
        return response.data?.body || null;
    } catch (error) {
        if (error.response?.status === 401 && !isRetry) {
            try {
                const newToken = await refreshToken();
                if (newToken) return await bannerApiRequest(endpoint, payload, true);
            } catch (refreshError) {
                console.error('Failed to refresh token:', refreshError);
            }
        }
        console.error(`Failed to call ${endpoint} with payload:`, payload, error);
        return null;
    }
}

// Fetch banner data
export const fetchBannerData = async () => bannerApiRequest('v1/pullbanner');

// Save banner data
export const saveBannerData = async (bannerData) => bannerApiRequest('v1/savebanner', bannerData);
